// Дзеркало Prisma enum RuleScope. Область дії правила розкладу.
// Значення ідентичні apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts). Підписи — лише тут.
export const RuleScope = {
    ALL: 'ALL',
    FACULTY: 'FACULTY',
    COURSE: 'COURSE',
};
/** Значення в порядку оголошення в схемі. */
export const RULE_SCOPE_VALUES = ['ALL', 'FACULTY', 'COURSE'];
export const RULE_SCOPE_LABELS = {
    ALL: 'Увесь університет',
    FACULTY: 'Факультет',
    COURSE: 'Курс',
};
//# sourceMappingURL=rule-scope.js.map